import { axiosServicesV1 } from 'utils/services';

import { decryptId } from 'common/decrypt';

const dashboardNotificationAPI = async (applicantID: string) => {
    // to decrypt user id in local storage
    const decrypted = await decryptId(applicantID || '', 'decrypt');

    try {
        const response = await axiosServicesV1.get(`data_iris/D_GetNotifications?ApplicantID=${decrypted}`);
        if (response?.data?.pxResults) {
            return response.data.pxResults;
        }
    } catch (error) {
        console.error(error);
    }
    return [];
};

export default dashboardNotificationAPI;

export const ReadNotification = async (puGUID: string, date: string, IsDeactivated: string, ReadReceipt: string) => {
    try {
        const response = await axiosServicesV1.patch('savedata/IMDA-Data-Notification', {
            pyGUID: puGUID,
            Notification: {
                IsDeactivated,
                DateRead: date,
                ReadReceipt
            }
        });
        if (response?.status) {
            return response.status;
        }
    } catch (err) {
        console.error(err);
    }
    return false;
};
